import { render, staticRenderFns } from "./PSServices.vue?vue&type=template&id=2c13bc0e&scoped=true"
import script from "./PSServices.vue?vue&type=script&lang=js"
export * from "./PSServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c13bc0e",
  null
  
)

export default component.exports